import { ICreateAuditoresUseCase } from "../../../presentation/useCases/create/create_auditores_servicos_use_case";
import { IDeleteAuditoresUseCase } from "../../../presentation/useCases/delete/delete_auditores_servicos_use_case";
import { IAuditorRepository } from "../../repositories/auditor_repository";

// DeleteAuditoresUseCase

export class DeleteAuditoresUseCase implements IDeleteAuditoresUseCase {
  constructor(private readonly repository: IAuditorRepository) {}

  async deleteAuditores(IdAuditor: number): Promise<void> {
    
    await this.repository.deleteAuditores(IdAuditor);
  }
}
